(function () {
  if (window.__cartDrawerAtcInitialised) return;
  window.__cartDrawerAtcInitialised = true;

  function setLoading(button, isLoading) {
    if (isLoading) {
      button.classList.add('loading');
      button.disabled = true;
    } else {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }

  function updateCartBadge(count) {
    document.querySelectorAll('.thb-item-count').forEach(function (el) {
      el.textContent = count > 99 ? '*' : count;
      el.removeAttribute('hidden');
      el.style.display = '';
    });
  }

  function openCartDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    document.body.classList.add('open-cc');
    drawer.classList.add('active');
    drawer.focus();
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart-drawer:open');
    }
  }

  function refreshDrawerContents(callback) {
    fetch('/?section_id=cart-drawer', {
      headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newInner  = doc.querySelector('#Cart-Drawer .side-panel-inner');
      var curInner  = document.querySelector('#Cart-Drawer .side-panel-inner');
      if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
    })
    .catch(function (err) {
      console.warn('[cart-drawer-atc] drawer refresh failed:', err);
    })
    .finally(function () {
      if (typeof callback === 'function') callback();
    });
  }

  // Single delegated listener — works for any button with .js-cart-drawer-atc
  document.addEventListener('click', function (e) {
    var button = e.target.closest('.js-cart-drawer-atc');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    if (button.classList.contains('loading') || button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    setLoading(button, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function () {
      return fetch('/cart.js', {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
    })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      updateCartBadge(cart.item_count);
      refreshDrawerContents(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cart }
        }));
        openCartDrawer();
      });
    })
    .catch(function (err) {
      console.error('[cart-drawer-atc] error:', err);
    })
    .finally(function () {
      setLoading(button, false);
    });
  });

})();